var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1925 2.6925C12.9075 2.4075 12.525 2.25 12.1275 2.25H3.75C2.9175 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V5.8725C15.75 5.475 15.5925 5.0925 15.3075 4.815L13.1925 2.6925ZM9 14.25C7.755 14.25 6.75 13.245 6.75 12C6.75 10.755 7.755 9.75 9 9.75C10.245 9.75 11.25 10.755 11.25 12C11.25 13.245 10.245 14.25 9 14.25ZM9.75 6.75H5.25C4.425 6.75 3.75 6.075 3.75 5.25C3.75 4.425 4.425 3.75 5.25 3.75H9.75C10.575 3.75 11.25 4.425 11.25 5.25C11.25 6.075 10.575 6.75 9.75 6.75Z",
    fill: "#798fad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDisabled);
export default __webpack_public_path__ + "static/media/save-disabled.15128207eaeea1c18d8908797ce02eb7.svg";
export { ForwardRef as ReactComponent };